import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './PhproductformAPI';
import {getColumns} from './PhproductformStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getPhproductformView} from './PhproductformView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deletePhproductformObj  ,setSelectedPhproductformId,setPhproductformManagePackagingMaterialModal,setSelectedActionId , setShowEditForPhproductform} from 'store/slice/PharmaSlice';

import PhproductformListTable from './components/PhproductformListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';
import PhproductformFilterCriteria from './PhproductformFilterCriteria';


import VerticalShadesClosedIcon from '@mui/icons-material/VerticalShadesClosed';

import ManagePackagingMaterialActionModal from './action/managePackagingMaterial/ManagePackagingMaterialActionModal';

import { transformDateValue } from 'core/js/FormUtils';

export default function PhproductformList( {tableList, cardList, setShowEdit, setPhproductformId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice)

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, phproductformObj} = useSelector((state)=>state.pharmaslice.phproductformDashboard);
  const { phproductformList } = useSelector((state) => state.pharmaslice.phproductformDashboard);

  useEffect(() => {
  }, [phproductformList, phproductformObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedPhproductformId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deletePhproductformObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedPhproductformId(id));
    dispatch(setShowEditForPhproductform(true));
  }
  
  const createPhproductform=()=>{
    dispatch(setSelectedPhproductformId(-1));
    dispatch(setShowEditForPhproductform(true));
  }


  const managePackagingMaterialCallBack = (id) =>{
    dispatch(setSelectedPhproductformId(id));
    dispatch(setPhproductformManagePackagingMaterialModal(true));
  }

const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,

    }
    return newData;
  }
  const phproductformTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    phproductformList:phproductformList,
    cardList:getPhproductformView(tableList),
        actionList: [
          /*{title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        {id:91, title:'Manage Packaging Material', callBackMethod:managePackagingMaterialCallBack, icon:<VerticalShadesClosedIcon/>, status:'Draft', role:''},
        */
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:phproductformTransformation(tableList),
      phproductformList:phproductformList,
      actionList:[
        {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
        {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
        {id:91, title:'Manage Packaging Material', callBackMethod:managePackagingMaterialCallBack, icon:<VerticalShadesClosedIcon/>, status:'Draft', role:''},
      ]
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column">
              <Grid item>
                  <Grid container direction="row" justifyContent={'space-between'} alignContent={'center'} sx={{height:showfilter?'55px':'35px'}}>
                      <Grid item  lg={3}>
                        <Typography variant='h4' color="primary.darker">Product Form</Typography>
                      </Grid>
                      <Grid item lg={8}>
                      {showfilter ?  < PhproductformFilterCriteria  />: <></>}
                      </Grid>
                      <Grid item lg={1}>
                        <Grid container justifyContent={'flex-end'}>
                        {showfilter?
                            <Grid item>
                              <Tooltip title="Hide filter" sx={{cursor: "pointer"}}>
                                <FilterAltOffIcon onClick={()=>{dispatch(setFilter(false))}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Show filter" sx={{cursor: "pointer"}}>
                                <FilterAltIcon onClick={()=>{dispatch(setFilter(true))}}/>
                              </Tooltip>
                            </Grid>
                            }
                            {/*view===1?
                            <Grid item>
                              <Tooltip title="Grid View" sx={{cursor: "pointer"}}>
                                <ViewWeekIcon onClick={()=>{setView(0)}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Table View" sx={{cursor: "pointer"}}>
                                <CalendarViewMonthIcon onClick={()=>{setView(1)}}/>
                              </Tooltip>
                            </Grid>
                            */}
                            <Grid item>
                              <Tooltip title="Add Phproductform" sx={{cursor: "pointer"}}>
                                <AddIcon onClick={()=>{createPhproductform()}}/>
                              </Tooltip>
                            </Grid>
                          </Grid>
                      </Grid>
                      
                  </Grid>
              </Grid>
              <Grid item>
                < PhproductformListTable 
                  payload={getPayload().tableView}
                  />
                  
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
<ManagePackagingMaterialActionModal/>
    </>
);


}